<template>
  <div v-show="isVisible">
    <slot></slot>
  </div>
</template>

<script>
import { useMemoryState } from '../composables/ShowOnDemandByScrollMemory.js'

export default {
  props: {
    target: {
      type: String,
      required: true
    }
  },

  setup() {
    const { setMemoryState } = useMemoryState()

    return {
      setMemoryState
    }
  },

  data() {
    return {
      isVisible: false,
      targetEl: null
    }
  },
  methods: {
    scrollWatcher() {
      if (!this.targetEl) return false

      let rect = this.targetEl.getBoundingClientRect()
      this.isVisible = false

      if (rect.bottom < 0) {
        this.isVisible = true
      }
    }
  },
  watch: {
    isVisible: {
      handler(v) {
        this.setMemoryState(v)
      },
      immediate: true
    }
  },
  mounted() {
    setTimeout(() => {
      this.targetEl = document.querySelector(this.target)
      window.addEventListener('scroll', this.scrollWatcher)
    }, 1)
  },
  unmounted() {
    window.removeEventListener('scroll', this.scrollWatcher)
  }
}
</script>
